module.exports = __webpack_public_path__ + "img/hw-s13.e70772be.svg";